import { render } from "./VideoConference.vue?vue&type=template&id=094c75cc&ts=true&lang=pug"
import script from "./VideoConference.vue?vue&type=script&lang=ts"
export * from "./VideoConference.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__